import axios from 'axios'
// Define las configuraciones básicas y la url base del backend.
export default() => {
  let tokenStr = sessionStorage.getItem("id_token");
  let token = sessionStorage.getItem("token");

  return axios.create({

    baseURL: 'https://www.tu-gps-app.com/api/',
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      "Authorization" : `Bearer ${tokenStr}`,
      'Content-Type': 'application/json;charset=UTF-8',
      "Access-Control-Allow-Origin": "*",
      'token':token==null?"":token
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js